import { useEffect } from "@/utils/hooks/reactUseCustomHooks";
import { Search } from "../../Search/GlobalSearch";
import QuickMenu from "../QuickMenu";
import { addDataLayer } from "@/helpers/dataLayer";
import { Box, SlidePanel, Text } from "@dxp-feed/ui";
import React from "react";
import MegaMenu from "@/components/Header/MegaMenu";
import useMediaQuery from "@/utils/hooks/useMediaQuery"; // Ensure this hook returns the window width
import ImageWrapper from "@/components/ImageWrapper";
import Link from "@/components/Link";

const HamburgerMenu = ({
  headerData,
  setIsPanelOpen,
  isPanelOpen,
  searchStaticAEMData,
  quickLink,
  mobileLogoImage
}: any) => {
  const mobileMedia: number = useMediaQuery() ?? 0;
  const isMobile = mobileMedia && mobileMedia <= 1023;
  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
  };
  //off panel open if tour guide pop up is open
  useEffect(() => {
    const handler = () => {
      setIsPanelOpen(false);
    };
    window.addEventListener("guide-activated", handler);
    return () => window.removeEventListener("guide-activated", handler);
  }, []);

  useEffect(() => {
    if (isPanelOpen && isMobile) {
      document.body.classList.add("noScroll");
    } else {
      document.body.classList.remove("noScroll");
    }

    return () => {
      document.body.classList.remove("noScroll");
    };
  }, [isPanelOpen, isMobile]);

  if (!isMobile) return null;

  return (
    <Box>
      <Box as="div" className="z-40">
        <button
          aria-label="click here"
          onClick={() => {
            setIsPanelOpen(!isPanelOpen);
            addDataLayer({
              event: "button_click",
              click_text: "Hamburger_click",
              click_url: "nav_bar",
              page_title: document.title,
            });
          }}
        >
          <Text
            as="span"
            className="icon-toggle text-[18px] text-brandWhite"
          ></Text>
        </button>

        <SlidePanel
          side="left"
          isOpen={isPanelOpen}
          className="w-full Navigation-menu left-0 right-0 z-[99999] sm:w-[60%] overflow-hidden overflow-y-scroll scroll-touch bg-brandWhite h-full"
          overlayClass="bg-overlay"
          onClose={togglePanel}
        >
          <Box as="div" className="flex px-6 py-4 relative">
            <Box as="div">
              <Link
                href="/"
                onClick={() => {
                  setIsPanelOpen(false);
                }}
                aria-label={"Sobeys Logo Mobile"}
              >
                <ImageWrapper
                  src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${mobileLogoImage || ""}`}
                  alt={headerData?.logoalt || "Sobeys Logo"}
                  width="98"
                  height="48"
                  className="w-[98px] min-h-auto"
                />
              </Link>
            </Box>

            <button
              aria-label="Click Here"
              onClick={() => {
                setIsPanelOpen(!isPanelOpen);
                addDataLayer({
                  event: "button_click",
                  click_text: "Hamburger_click",
                  click_url: "nav_bar",
                  page_title: document.title,
                });
              }}
            >
              <Text
                as="span"
                className="icon-close text-[18px] absolute right-6 top-6"
              ></Text>
            </button>
          </Box>
          <Search
            isMobile
            className="px-6 mobile-hamburger-search"
            placeholder="Search"
            searchStaticAEMData={searchStaticAEMData}
            setIsPanelOpen={setIsPanelOpen}
          />
          <Box as="div" className="relative bg-brandWhite">
            <MegaMenu headerData={headerData} setIsPanelOpen={setIsPanelOpen} />
            <Box as="div" className="mobile-menu-category">
              <QuickMenu quickLink={quickLink} />
            </Box>
          </Box>
        </SlidePanel>
      </Box>
    </Box>
  );
};

export default HamburgerMenu;
